// extracted by mini-css-extract-plugin
export var container = "_jf-1";
export var editor = "_jf-2";
export var resizable = "_jf-3";
export var wrapper = "_jf-0";